<div class="value-selector-wrapper">
  <h4 class="title">{{ title }}</h4>
  <div class="center">
    <div class="toggle" [class.disabled]="disabled">
      <input
        [id]="id"
        type="checkbox"
        [name]="id"
        [disabled]="disabled"
        [class.disabled]="disabled"
        [checked]="isChecked()"
        (click)="toggle()"
      />
      <label [for]="id" class="label-one" [class.selected]="isChecked()"
        ><span>{{ labelOne }}</span></label
      >
      <label [for]="id" class="label-two" [class.selected]="!isChecked()"
        ><span>{{ labelTwo }}</span></label
      >
    </div>
  </div>
</div>
